import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';
import markerUrl from '../../images/map-marker.png';

export default class extends Controller {
    connect() {
        const position = [55.688760, 21.153187];

        const map = Leaflet.map(this.element, {
            center: position,
            zoom: 15,
            scrollWheelZoom: false,
        });

        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '',
            id: 'linask/cl13mi0it000n14o1n7kehdmz',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoibGluYXNrIiwiYSI6ImNrMHFvcjNhcTAxcWgzbWtkajJsNnExZGYifQ.Ll4K0FodbnpglE8a2C51pg',
        }).addTo(map);

        Leaflet.marker(position, {
            icon: new (Leaflet.Icon.extend({
                options: {
                    iconSize: [32, 41],
                    iconAnchor: [16, 41],
                },
            }))({ iconUrl: markerUrl }),
        }).addTo(map);
    }
}
